/**
 * Pure component for common multi enum dropdown
 */
import { forwardRef } from 'react';
import { DefaultItem } from '@adsk/alloy-react-dropdown';
import { CommonFormField } from '../CommonFormField';
import { PureEnumMultiDropdown, PureEnumMultiDropdownProps } from './PureEnumMultiDropdown';

export type PureEnumMultiDropdownFieldProps = {
  fieldName: PureEnumMultiDropdownProps['fieldName'];
  value?: string[];
  onChange: (value: DefaultItem[]) => void;
  id?: string;
  label?: string;
  required?: boolean;
  error?: string;
  disabled?: boolean;
  placeholder?: string;
  clearable?: boolean;
  withUnspecified?: boolean;
  'data-testid'?: string;
};

export const PureEnumMultiDropdownField = forwardRef<
  HTMLDivElement,
  PureEnumMultiDropdownFieldProps
>(
  (
    {
      fieldName,
      value,
      onChange,
      id,
      label,
      required,
      error,
      disabled,
      placeholder,
      clearable,
      withUnspecified = false,
      'data-testid': dataTestId,
    },
    ref,
  ) => (
    <CommonFormField label={label} required={required} error={error} ref={ref}>
      <PureEnumMultiDropdown
        fieldName={fieldName}
        value={value}
        onChange={onChange}
        id={id}
        disabled={disabled}
        placeholder={placeholder}
        clearable={clearable}
        withUnspecified={withUnspecified}
        data-testid={dataTestId}
        error={!!error}
      />
    </CommonFormField>
  ),
);
